import Head from 'next/head';

import { Breadcrumb, createBreadcrumbStructuredData } from '../utils/create-breadcrumb-structured-data';

export function BreadcrumbStructuredData({ crumbs }: { crumbs: Breadcrumb[] }) {
  if (!crumbs.length) return null;
  const structuredData = {
    '@context': 'https://schema.org',
    ...createBreadcrumbStructuredData(crumbs),
  };
  return (
    <Head>
      <script
        key='structured-data-breadcrumb'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        type='application/ld+json'
      />
    </Head>
  );
}
